module.exports = __webpack_public_path__ + "img/HD_bt_zi_15b85cc25.png";